import { STORE_DATA, STORE_LOCALE } from '@core/local-storage/local-storage';
import { Company } from '@core/models/common/company';
import { ConnectionPermission } from '@core/models/connection/connection-permission';
import { User } from '@core/models/user/user';
import { environment } from '@environments/environment';
import moment from 'moment';

export interface ISessionState {
  user: User;
  locale: string;
  company: Company;
  companyFeatures: any;
  companyStatus: any;
  companyInstallDate: moment.Moment;
  permissions: ConnectionPermission[];
  country: any;
  skillSets: any[];
  initSessionComplete: boolean;
}

export const initialState: ISessionState = {
  user: null,
  locale: null,
  company: null,
  companyFeatures: null,
  companyStatus: null,
  companyInstallDate: null,
  permissions: null,
  country: null,
  skillSets: null,
  initSessionComplete: false
}

export function initialSessionState() {
  const w: any = window;
  let session = { ...initialState };
  const defaultLocale: string = 'en-US';
  let locale = defaultLocale;

  try {
    session = JSON.parse(w.localStorage.getItem(`${environment.settings.localStoragePrefix}.${ STORE_DATA }`)) || { ...initialState };
  } catch (error) {
    console.error(error);
  }

  try {
      locale = JSON.parse(w.localStorage.getItem(`${environment.settings.localStoragePrefix}.${ STORE_LOCALE }`)) || defaultLocale;
  } catch (error) {
    console.error(error);
  }
  
  session['locale'] = locale;

  return session;
}